import useSWR, { SWRResponse } from 'swr';
import { PendingDispersion } from './useGetPendingDispersions';

/**
 * Fetches a pending dispersion by id
 * @param id - Pending dispersion id
 */
const useGetPendingDispersionById = (
  id?: string
): SWRResponse<PendingDispersion, Error> & {
  dispersion: PendingDispersion | undefined;
} => {
  const props = useSWR<PendingDispersion, Error>(id ? `/v3/dispersion/pending/${id}` : null, {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  return {
    ...props,
    dispersion: props.data,
  };
};

export default useGetPendingDispersionById;
